import App from "./InfiniteItems/App.svelte";

[...document.querySelectorAll("[data-infinite]")].forEach((target) => {
    const props = JSON.parse(target.dataset.infinite);
    new App({ target, props });
});
